import { LOCAL_ZONES_TYPES } from '../../../consts/config';

const allLocalZonesReducer = (state = {}, action) => {
  switch (action.type) {
    case 'SET_LOCAL_ZONES':
      return { ...action.payload };
    case 'REMOVE_LOCAL_ZONE':
      return {
        ...state,
        [LOCAL_ZONES_TYPES[action.payload.type]]: state[
          LOCAL_ZONES_TYPES[action.payload.type]
        ].filter(localZone => localZone.uid !== action.payload.uid),
      };
    case 'ADD_LOCAL_ZONE':
      if (!state[LOCAL_ZONES_TYPES[action.payload.type]]) {
        state[LOCAL_ZONES_TYPES[action.payload.type]] = [];
      }
      return {
        ...state,
        [LOCAL_ZONES_TYPES[action.payload.type]]: [
          ...state[LOCAL_ZONES_TYPES[action.payload.type]],
          { ...action.payload, activations: [] },
        ],
      };
    case 'EDIT_LOCAL_ZONE':
      return handleEdit(state, action.payload);
    default:
      return state;
  }
};

const handleEdit = (zones, zoneToEdit) => {
  const tmpState = {};
  for (const key of Object.keys(zones)) {
    tmpState[key] = zones[key].filter(z => z.uid !== zoneToEdit.uid);
  }
  tmpState[LOCAL_ZONES_TYPES[zoneToEdit.type]].push(zoneToEdit);

  return tmpState;
};
export default allLocalZonesReducer;
